import BaseModelAPI from '../BaseModelAPI';

export default class VendorTypeList extends BaseModelAPI {

	static entity = 'vendor typelist'
	static entityName = 'vendortype';

	constructor() {
		this.pageIndex = 0;
		this.pageSize = 0;
		this.pageCount = 0;
		this.dataCount = 0;
	}
}
